// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

type HeadlineType = "h1" | "h2" | "h3" | "subline" | "big";
type ColorType = "black" | "white";

@Component({
  mixins: [template],
})
export class Headline extends Vue {
  @Prop({ default: "h1" })
  public type!: HeadlineType;

  @Prop({ default: "" })
  public weight!: string;

  @Prop({ default: "black" })
  public backgroundColor!: ColorType;

  @Prop({ default: false })
  public forceLine!: boolean;

  @Prop({ default: false })
  public disableLine!: boolean;

  @Prop({ default: false })
  public center!: boolean;

  public themeMap = {
    1: 1,
    2: 3,
    3: 6,
    4: 21,
  };

  get headlineSize() {
    switch (this.type) {
      case "h1":
        return 1;
      case "big":
        return 1;
      case "h2":
        return 2;
      case "h3":
        return 3;
      case "subline":
        return 4;
      default:
        return 1;
    }
  }

  get headingClass() {
    return `wb-e-hdl-${this.themeMap[this.headlineSize]}`;
  }

  get headingLineClass() {
    return this.hasHeadlineLine
      ? `${this.$appPrefix}-h--line-${this.headlineSize}`
      : "";
  }

  get headlineComponentName() {
    return this.weight === "" ? `h${this.headlineSize}` : this.weight;
  }

  get headlineTheme() {
    return this.backgroundColor == "white" ? "default" : "secondary";
  }

  get hasHeadlineLine() {
    return this.forceLine || (this.type == "h2" && !this.disableLine);
  }

  get bigHeadlineClass() {
    return this.type == "big" ? "cms-headline--big" : "";
  }

  get alignClass() {
    return this.center ? "cms-headline--center" : "";
  }
}
